import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useContext } from 'react';
import { Combobox } from '@paypalcorp/pp-react-combobox';
import { IntlContext } from '@paypalcorp/pp-react-intl';
import { Flag } from '@paypalcorp/pp-react-flag';
var _excluded = ["name", "value", "label", "countryList", "onOpen", "onChange", "onFocus", "sheetWrapperClassName"],
    _excluded2 = ["countryCode", "label"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var CountryInput = function CountryInput(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'default' : _ref$name,
      value = _ref.value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Country or region' : _ref$label,
      _ref$countryList = _ref.countryList,
      countryList = _ref$countryList === void 0 ? [] : _ref$countryList,
      onOpen = _ref.onOpen,
      onChange = _ref.onChange,
      _ref$onFocus = _ref.onFocus,
      onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
      sheetWrapperClassName = _ref.sheetWrapperClassName,
      rest = _objectWithoutProperties(_ref, _excluded);
  /* istanbul ignore next */


  if (!countryList || !(countryList === null || countryList === void 0 ? void 0 : countryList.length)) {
    console.warn('Required prop `countryList` is missing.');
  }

  var intlContext = useContext(IntlContext);
  var options;

  var filterProps = function filterProps(country, displayNamesObj) {
    var countryCode = country.countryCode,
        optionLabel = country.label,
        optionRest = _objectWithoutProperties(country, _excluded2); // istanbul ignore next


    return _objectSpread({
      label: optionLabel || displayNamesObj && displayNamesObj.select(countryCode),
      value: countryCode,
      decoration: /*#__PURE__*/React.createElement(Flag, {
        countryCode: countryCode,
        size: "md",
        "data-ppui": "true"
      })
    }, optionRest);
  };
  /* istanbul ignore else */


  if (!intlContext || !intlContext.getDisplayNamesObject) {
    options = countryList.map(function (country) {
      return filterProps(country, null);
    });
  } else {
    var displayNamesObj = intlContext.getDisplayNamesObject({
      type: 'region'
    });
    options = countryList.map(function (country) {
      return filterProps(country, displayNamesObj);
    });
  }

  return /*#__PURE__*/React.createElement(Combobox, _extends({
    name: name,
    value: value,
    options: options,
    label: label,
    onOpen: onOpen,
    onChange: onChange,
    onFocus: onFocus,
    sheetWrapperClassName: sheetWrapperClassName,
    "data-ppui-info": "country-input_2.4.19"
  }, rest));
};

export { CountryInput };